import { Box, ThemeProvider } from '@mui/material'
import { Outlet } from 'react-router-dom'

import { PlatformTopbar } from '@/super-admin/layouts/PlatformTopbar'
import { SidebarSuperAdmin, SIDEBAR_SUPER_ADMIN_WIDTH } from '@/super-admin/layouts/SidebarSuperAdmin'
import { platformSurfaces, superAdminTheme } from '@/super-admin/theme'

/**
 * Shell exclusiva de la GOVIA Platform Console (administración SaaS),
 * separada del cliente (AppLayout / AppShellV2): tema anidado propio,
 * sidebar de plataforma, topbar de plataforma y área de contenido ancha.
 * Se monta DENTRO de <ProtectedRoute> + <PlatformOperatorRoute>
 * (routes/AppRoutes.tsx); la autoridad real sigue siendo el backend
 * (require_platform_operator en cada endpoint /super-admin/*).
 */
export function AppShellSuperAdmin() {
  return (
    <ThemeProvider theme={superAdminTheme}>
      <Box sx={{ display: 'flex', minHeight: '100vh', bgcolor: platformSurfaces.canvas, color: 'text.primary' }}>
        <SidebarSuperAdmin />
        <Box component="main" sx={{ flex: 1, minWidth: 0, ml: `${SIDEBAR_SUPER_ADMIN_WIDTH}px` }}>
          <PlatformTopbar />
          <Box sx={{ px: { xs: 2, md: 4 }, py: 3, maxWidth: 1680 }}>
            <Outlet />
          </Box>
        </Box>
      </Box>
    </ThemeProvider>
  )
}
